import React from 'react';
import $ from 'jquery';
 
import TocPage from './generic/TocPage';
import getLegalLinks from './Legal/getLegalLinks';
 
import '../css/prices.css';
 
import aviso29 from '../media/Aviso Importante 29jul21.pdf';
import aviso30 from '../media/AVISO IMPORTANTE_ONInternet2022.pdf';
import aviso31 from '../media/AVISOIMPORTANTEdiciembre2023.pdf';
import aviso32 from '../media/AVISOIMPORTANTEdiciembre2025.pdf';
import aviso33 from '../media/AVISOIMPORTANTEnero2026.pdf';
import aviso34 from '../media/AVISOIMPORTANTEdiciembre2026.pdf';
const Prices = props =>
{
 
 
    return (
<div id='prices' className='container-fluid p-4'>
<TocPage history={props.history} links={getLegalLinks()}>
<h3>AVISO</h3>
<p><a href={aviso34} target='_blank'>Ajuste en tarifas ON Internet a partir del 1 de diciembre 2026</a></p>
<p><a href={aviso33} target='_blank'>Ajuste en tarifas ON Inalámbrico a partir del 1 de enero de 2026</a></p>
<p><a href={aviso32} target='_blank'>Ajuste en tarifas ON Inalámbrico a partir del 1 de enero de 2025</a></p>
<p><a href={aviso31} target='_blank'>Ajuste en tarifas ON Inalámbrico a partir del 1 de enero de 2024</a></p>
<p><a href={aviso30} target='_blank'>Ajuste en tarifas ON Inalámbrico a partir del 4 de febrero 2022</a></p>
<p><a href={aviso29} target='_blank'> Ajuste en tarifas ON Inalámbrico a partir del 1 de septiembre de 2021</a></p>
</TocPage>
</div>
    );
}
 
export default Prices;



// WEBPACK FOOTER //
// ./src/components/Avisoimport.js